<!-- Backdrop -->
<div class="cc-backdrop" [class.cc-backdrop--open]="isOpen()" (click)="close()" aria-hidden="true"></div>

<!-- Consent panel -->
<div class="cc-panel" [class.cc-panel--open]="isOpen()" role="dialog" aria-modal="true" aria-labelledby="cc-title">

  <div class="cc-panel__header">
    <img src="Images/Logo_everlume.png" alt="Everlume Solutions" class="cc-panel__logo" />
    <h2 id="cc-title" class="cc-panel__title">Manage Consent</h2>
    <button type="button" class="cc-panel__close" (click)="close()" aria-label="Close">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  <div class="cc-panel__body">
    <p class="cc-panel__intro">
      We use cookies to provide an exceptional user experience and analyze website traffic. Cookies enable you to enjoy certain features and allow us to understand how our site is being used. By clicking on "Accept all" or using the website, you agree to our use of cookies. You may reject optional cookies in the View Preferences or block cookies in your browser. Please find more information on our use of cookies and how to withdraw your consent on our
      <a routerLink="/privacy-policy" (click)="close()">Privacy Policy</a>.
    </p>

    <ul class="cc-list" role="list">
      @for (cat of categories; track cat.key) {
        <li class="cc-item" [class.cc-item--open]="expandedKey === cat.key">
          <div class="cc-item__row">
            <span class="cc-item__label">{{ cat.label }}</span>
            <div class="cc-item__controls">
              @if (cat.alwaysActive) {
                <span class="cc-item__always">Always active</span>
              } @else if (cat.key === 'functional') {
                <button type="button" class="cc-switch" [class.cc-switch--on]="functional"
                  (click)="toggle('functional')" [attr.aria-pressed]="functional" aria-label="Toggle Functional cookies">
                  <span class="cc-switch__thumb"></span>
                </button>
              } @else if (cat.key === 'analytics') {
                <button type="button" class="cc-switch" [class.cc-switch--on]="analytics"
                  (click)="toggle('analytics')" [attr.aria-pressed]="analytics" aria-label="Toggle Analytics cookies">
                  <span class="cc-switch__thumb"></span>
                </button>
              } @else if (cat.key === 'advertising') {
                <button type="button" class="cc-switch" [class.cc-switch--on]="advertising"
                  (click)="toggle('advertising')" [attr.aria-pressed]="advertising" aria-label="Toggle Advertising cookies">
                  <span class="cc-switch__thumb"></span>
                </button>
              }
              <button type="button" class="cc-item__chevron" (click)="toggleExpand(cat.key)"
                [attr.aria-expanded]="expandedKey === cat.key" [attr.aria-label]="'Show details for ' + cat.label">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
          @if (expandedKey === cat.key) {
            <p class="cc-item__desc">{{ cat.description }}</p>
          }
        </li>
      }
    </ul>
  </div>

  <div class="cc-panel__footer">
    <div class="cc-panel__actions">
      <button type="button" class="cc-btn cc-btn--primary" (click)="acceptAll()">Accept all</button>
      <button type="button" class="cc-btn cc-btn--ghost" (click)="denyAll()">Deny all</button>
      <button type="button" class="cc-btn cc-btn--ghost" (click)="savePreferences()">Save preferences</button>
    </div>
  </div>
</div>
